import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const OctapharmaChargebacksSourceDatamonthly = () => {
	const fileName = "Octapharma Chargebacks Source Data ";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const history = useHistory();
	const [octapharmaChargeBacks, setOctapharmaChargeBacks] = useState([]);
	const [loading, setLoading] = useState(false);
	// const [showToaster, setShowToaster] = useState(false);
	// let Message;
	const [hasError, setHasError] = useState(false);
	// excel Headers
	const excelColumns = [
		{
			Header: "Distributor Name",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
			width: 150,
		},
		{
			Header: "Distribution Location (state abbreviation)",
			accessor: "DistributionLocationState",
			filter: "DistributionLocationState",
			sortType: "basic",
		},
		{
			Header: "Report Date",
			accessor: "ReportDate",
			filter: "ReportDate",
			sortType: "basic",
			width: 120,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Debit Memo#",
			accessor: "DebitMemoNum",
			filter: "DebitMemoNum",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Submitted - CB Cust ID#",
			accessor: "CustID",
			filter: "CustID",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - CB Cust ID#",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "CB Cust GPO or HRSA ID# (when applicable)",
			accessor: "CustGPOORHRSAID",
			filter: "CustGPOORHRSAID",
			sortType: "basic",
		},
		{
			Header: "Submitted - CB Cust Name",
			accessor: "CustName",
			filter: "CustName",
			sortType: "basic",
			width: 300,
		},
		{
			Header: "Octapharma validated - CB Cust Name",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - CB Cust Address",
			accessor: "CustAddress",
			filter: "CustAddress",
			sortType: "basic",
			width: 220,
		},
		{
			Header: "Octapharma validated - CB Cust Address",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - CB Cust City",
			accessor: "CustCity",
			filter: "CustCity",
			sortType: "CustCity",
		},
		{
			Header: "Octapharma validated - CB Cust City",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - CB Cust State",
			accessor: "CustState",
			filter: "CustState",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - CB Cust State",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - CB Cust Zip",
			accessor: "CustZip",
			filter: "CustZip",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - CB Cust Zip",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - CB Customer's Invoice#",
			accessor: "CustomersInvoice",
			filter: "CustomersInvoice",
			sortType: "basic",
		},
		{
			Header: "Submitted CB Customer's Invoice Date",
			accessor: "CustomersInvoiceDate",
			filter: "CustomersInvoiceDate",
			sortType: "basic",
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Submitted Contract Reference#",
			accessor: "ContractReference",
			filter: "ContractReference",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Contract Reference#",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - Product NDC-11",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Product NDC-11",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Product Description (Octapharma validated)",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			sortType: "basic",
			width: 250,
		},
		{
			Header: "Sale Qty",
			accessor: "SaleQTY",
			filter: "SaleQTY",
			sortType: "basic",
			width: 100,
		},
		{
			Header: "Sale Qty UOM",
			accessor: "SaleQTYUOM",
			filter: "SaleQTYUOM",
			sortType: "basic",
			width: 115,
		},
		{
			Header: "Submitted - Dosage / Units",
			accessor: "DosageORUnits",
			filter: "DosageORUnits",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Dosage / Units",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Dosage / Units UOM",
			accessor: "DosageORUnitsUOM",
			filter: "DosageORUnitsUOM",
			sortType: "basic",
		},
		{
			Header: "Submitted - Total IUs/EUs/Grams",
			accessor: "Totalcount",
			filter: "Totalcount",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Total IUs/EUs/Grams",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - DAC per IU/EU/Gram",
			accessor: "DACperIUOREUORGram",
			filter: "DACperIUOREUORGram",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - DAC (priced per IU/EU/Gram)",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - Contract price per IU/EU/Gram",
			accessor: "ContractpriceperIUOREUORGram",
			filter: "ContractpriceperIUOREUORGram",
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Contract price per IU/EU/Gram",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Submitted - Requested Extended Amount",
			accessor: "RequestedExtendedAmount",
			filter: "RequestedExtendedAmount",
			sortType: "basic",
		},
		// {
		//     Header: "Octapharma validated - Extended Amount (issued/deducted)",
		//     accessor: "",
		//     filter: "",
		//     sortType: "basic",
		// },
		// ==================
		{
			Header: "Octapharma validated - Extended Amount (issued/deducted)",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header:
				"Octapharma note: Reason for change, questions to distributors, or requests to correct data",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Octapharma note: Acceptance reasoning notes",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header:
				"Octapharma notes: Reason for rejection, or requests for further information from distributor",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Octapharma - Payment Date (check, wired, or deducted on dates)",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header:
				"Octapharma check#, Wire Transfer#, or Deduction transaction ref#",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Month/Year Payment processed at Octapharma",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Distributor Notification name (for chargeback use)",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header:
				"Octapharma - EDI pay/no pay line indicator: P - Process R - Rejected PA - Pay accrual amount D - Deducted",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Octapharma - EDI Source Indicator",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
	];

	useEffect(() => {
		getOctapharmaChargeBacks();
	}, []);
	async function getOctapharmaChargeBacks() {
		setLoading(true);
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=ChargebacksMonthly&TaskTypeCode=OctapharmaChargebacks`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const octapharmaChargeBacks = data.data;
				if (octapharmaChargeBacks.length > 0) {
					octapharmaChargeBacks.map((res) => {
						res.ReportDate = moment(res.ReportDate).format("MM/DD/YYYY");
						res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format(
							"MM/DD/YYYY"
						);
						res.RequestedExtendedAmount =
							"$" +
							(res.RequestedExtendedAmount * 1)
								.toFixed(2)
								.replace(/\d(?=(\d{3})+\.)/g, "$&,");
						res.DosageORUnits = (res.DosageORUnits * 1).toFixed(2);
						res.DACperIUOREUORGram =
							"$" + (res.DACperIUOREUORGram * 1).toFixed(2);
						res.ContractpriceperIUOREUORGram =
							"$" + (res.ContractpriceperIUOREUORGram * 1).toFixed(2);
						res.Totalcount = (res.Totalcount * 1).toFixed(2);
						// "$" +
					});
				}
				setOctapharmaChargeBacks(octapharmaChargeBacks);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				// Message = e.response.data.Message;
				// setShowToaster(true);
				setHasError(true);
			});
	}
	const EditRecords = () => {
		localStorage.setItem(
			"octapharmaChargeBacks",
			JSON.stringify(octapharmaChargeBacks)
		);
		history.push("/OctapharmaChargebacksEdit");
	};
	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<div>
					{octapharmaChargeBacks.length > 0 &&
						(outbounddata.FileSentStatus == "Sent" ? (
							<Button type="submit" onClick={() => EditRecords()}>
								Create Reversal
							</Button>
						) : (
							<Button type="submit" onClick={() => EditRecords()}>
								Edit Records
							</Button>
						))}
					<Button
						type="submit"
						className="ml-2"
						onClick={() =>
							getExcel(excelColumns, octapharmaChargeBacks, fileName)
						}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			{/* Toaster */}
			{/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}.</p>
								) : (
									<Fragment>
										{octapharmaChargeBacks.length > 0 ? (
											<ReactTable
												columns={excelColumns}
												data={octapharmaChargeBacks}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default OctapharmaChargebacksSourceDatamonthly;
